const style = {
  active: {
    background: `#f8f8f8`
  },
  editor: {
    minHeight: `300px`
    // background: `#f8f8f8`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/News/partials/PostEditor/style/editor.js